import { Component } from 'react'
import { connect } from 'react-redux'
import { PROPOSALS_FOR_REVIEW_FETCH_REQ } from '../actions'
import { ProposalsReviewTemplate } from 'components/Dashboard/ProposalsReviewTemplate'
import { fromProposals } from '../serializers'

@connect(({ dashboard }) => {
  return {
    dashboard
  }
})
class ProposalsForReviewContainer extends Component {
  componentDidMount() {
    this.props.dispatch({
      type: PROPOSALS_FOR_REVIEW_FETCH_REQ
    })
  }

  render() {
    return (
      <ProposalsReviewTemplate
        title="Proposals I Sent for Review"
        subTitle="Below is a list of opportunities I created proposals submitted for review"
        proposals={fromProposals(this.props.dashboard.proposalsISentForReview)}
      />
    )
  }
}

export default ProposalsForReviewContainer
